@if (confirmationService.dialog$ | async; as dialog) {
  <div class="confirmation-backdrop" @backdropAnimation (click)="onCancel()">
    <div class="confirmation-modal" @modalAnimation (click)="$event.stopPropagation()">
      <div class="confirmation-icon" [class]="'icon-' + dialog.confirmType">
        <i [class]="'bi ' + getIcon(dialog.confirmType)"></i>
      </div>
      
      <h3 class="confirmation-title">{{ dialog.title }}</h3>
      <p class="confirmation-message">{{ dialog.message }}</p>
      
      <div class="confirmation-actions">
        <button 
          class="btn-cancel" 
          (click)="onCancel()"
        >
          <i class="bi bi-x-lg"></i>
          <span>{{ dialog.cancelText }}</span>
        </button>
        <button 
          class="btn-confirm" 
          [class]="'btn-' + dialog.confirmType"
          (click)="onConfirm()" appThrottleClick
        >
          <i class="bi bi-check-lg"></i>
          <span>{{ dialog.confirmText }}</span>
        </button>
      </div>
    </div>
  </div>
}
